<template>
  <div class="evaluation-page" :class="{ inApp: $root.$data.isApp || isMiniProgram }">
    <common-title titleName="评价" :zIndex="1000" v-if="!isMiniProgram"></common-title>
    <template>
      <addEvaluation v-if="isAddEvaluation" :isMiniProgram='isMiniProgram' />
      <evaluationList v-else />
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import evaluationList from '@/pages/learningGuidePage/evaluation/evaluationList';
// eslint-disable-next-line import/extensions
import addEvaluation from '@/pages/learningGuidePage/evaluation/addEvaluation';
// eslint-disable-next-line import/extensions
import CommonTitle from '@/components/header/CommonTitle';
import { whatEev } from '@/utils/tools';

export default {
  components: { evaluationList, CommonTitle, addEvaluation },
  data() {
    return {
      isAddEvaluation: false,
      isMiniProgram: false,
    };
  },
  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
      document.title = '评价';
    }
  },
};
</script>

<style scoped>
.evaluation-page {
  padding-top: 100px;
}
.inApp {
  padding-top: 0;
}
</style>
